export default __webpack_public_path__ + "static/media/2021-toyota.54188648.jpg";